export default {
  MODULE_SETTINGS_PAGE_TITLE: '%PLATFORM% Settings',
};
